
import Vue from 'vue'
import { QInput, QSelect } from 'quasar'
import gql from 'graphql-tag'
import types from '@/helpers/types'
import EntryEdit from './EntryEdit.vue'

export default Vue.extend({
    components: { QInput, QSelect, EntryEdit },
    props: {
        entry: {
          type: Object
        },
        listId: {
          type: String
        },
        users: {
          type: <any>Array,
          default: () => ([])
        },
    },
    data() {
      return {
        entryClone: <{[key: string]: string}>{},
        isLoading: false
      }
    },
    mounted() {
      const fields = [
        'name',
        'mail',
        'type',
        'tel',
        'contactPerson',
        'website',
        'postcode',
        'city',
        'address',
        'responsible',
        'products',
        'comment'
      ]
      // this.entryClone = {}
      for(let key of fields) {
        Vue.set(this.entryClone, key, this.entry[key])
      }
    },
    methods: {
      async save(e: any) {
        if(e.shiftKey) return // don't submit on Shift+Enter
        this.isLoading = true
        try {
          const res = await this.$apollo.mutate({
            mutation: gql`
              mutation update ($id: String!, $data: EntryUpdateInput!, $listId: String!) {
                updateEntry(data: $data, listId: $listId, id: $id) {
                  id
                }
              }
            `,
            variables: {
              id: this.entry.id,
              data: this.entryClone,
              listId: this.listId 
            }
          })
          this.$emit('closeDialog') 
          this.isLoading = false
        } catch(err) {
          this.isLoading = false
          console.log(err)
        }
      },
    }
})

